import './icon-button.scss';

export { IconButton } from '@lambdacurry/component-library';
